<template>
  <div class="disciplinaryMeasure">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <employee-sidebar v-if="currentUser.employee.designation.departmentId === 14">
      </employee-sidebar>
      <layout-sidebar v-else></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Training Provider</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Training Provider</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a @click="openDialog" class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Provider</a
                >
                <a @click="openImport" class="btn add-btn mr-2"
                  ><i class="fa fa-plus"></i> Import Provider</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="providers"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <a class="dropdown-item" @click="setEditProvider(item)"
                          ><i class="fa fa-pencil m-r-5"></i> Edit</a
                        >
                        <a
                          class="dropdown-item"
                          @click="setDeleteProvider(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                        >
                        <!-- <a
                          class="dropdown-item"
                          @click="downloalProviderCurriculum"
                          ><i class="fa fa-trash-o m-r-5"></i> Download
                          Curriculum</a
                        > -->

                        <a
                          class="dropdown-item"
                          v-if="!item.curriculumUrl"
                          @click="openCurriculumBox(item)"
                          ><i class="fa fa-trash-o m-r-5"></i> Upload
                          Curriculum</a
                        >

                        <a
                          class="dropdown-item"
                          v-if="item.curriculumUrl"
                          :href="item.curriculumUrl"
                          ><i class="fa fa-trash-o m-r-5"></i> Download Training
                          Curriculum</a
                        >
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.type`]="{ item }">
                    {{ item.type == 1 ? "Personal" : "Group" }}
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add training provider Modal -->
        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Training Provider</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Skill Gap <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="skillGapId"
                    @change="getProgrammes"
                  >
                    <option>Select Skill Gap</option>
                    <option
                      v-for="member in skillGaps"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Program <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="trainingProgrammeId">
                    <option>Select Programme</option>
                    <option
                      v-for="member in trainingPrograms"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.programme }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Vendor <span class="text-danger">*</span></label>
                  <input
                    v-model="vendor"
                    id="vendor"
                    name="vendor"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="form-group">
                  <label>Type<span class="text-danger">*</span></label>
                  <select class="form-control" v-model="type">
                    <option>Select Type</option>
                    <option :value="1">Personal</option>
                    <option :value="2">Group</option>
                  </select>
                </div>
                <div class="form-group" v-if="type == 2">
                  <label
                    >No of Participants
                    <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="noOfParticipant"
                    id="program"
                    name="program"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="form-group">
                  <label>Tuition Fees <span class="text-danger">*</span></label>
                  <input
                    v-model="tuitionFee"
                    id="program"
                    name="program"
                    class="form-control"
                    type="number"
                  />
                </div>

                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Training Provide Modal -->

        <!-- Edit Training Provider Modal -->
        <v-dialog v-model="dialogEdit" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Training Provider</h5>
              <button type="button" class="close" @click="closeEdit">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Skill Gap <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="provider.trainingProgramme.skillGapId"
                    @change="getProgrammes"
                  >
                    <option>Select Skill Gap</option>
                    <option
                      v-for="member in skillGaps"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.name }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Program <span class="text-danger">*</span></label>
                  <select
                    class="form-control"
                    v-model="provider.trainingProgrammeId"
                  >
                    <option>Select Programme</option>
                    <option
                      v-for="member in trainingPrograms"
                      :key="member.id"
                      :value="member.id"
                    >
                      {{ member.programme }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Vendor <span class="text-danger">*</span></label>
                  <input
                    v-model="provider.vendor"
                    id="vendor"
                    name="vendor"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="form-group">
                  <label>Type<span class="text-danger">*</span></label>
                  <select class="form-control" v-model="provider.type">
                    <option>Select Type</option>
                    <option :value="1">Personal</option>
                    <option :value="2">Group</option>
                  </select>
                </div>
                <div class="form-group" v-if="provider.type == 2">
                  <label
                    >No of Participants
                    <span class="text-danger">*</span></label
                  >
                  <input
                    v-model="provider.noOfParticipant"
                    id="program"
                    name="program"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="form-group">
                  <label>Tuition Fee <span class="text-danger">*</span></label>
                  <input
                    v-model="provider.tuitionFee"
                    id="program"
                    name="program"
                    class="form-control"
                    type="number"
                  />
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onPutSubmit"
                    data-dismiss="modal"
                    class="btn btn-primary submit-btn"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Edit training needs Modal -->

        <!-- Delete training needs Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Training Needs</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      class="btn btn-primary continue-btn"
                      @click="onDeleteSubmit"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete disciplinaryCase Modal -->
        <!-- Delete Employee Modal -->
        <v-dialog v-model="dialogImport" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Provider</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closeImport"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Import Provider</h3>
                <p>
                  Download an excel template by clicking on the below button
                </p>
                <br />
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row) in first sheet only. <br />
                    Regards <strong>TrainingProgramme Number</strong> column you
                    are expected to get the value from its representing sheet.
                    <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr />
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importProvider"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Employee Modal -->

        <!-- Upload and Download Curriculum -->
        <v-dialog v-model="curriculumDialogBox" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Import Plan</h5>
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="closecurriculumDialogBox"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="alert alert-success alert-dismissible fade show"
                    role="alert"
                    v-if="message"
                  >
                    <strong>Success!</strong> {{ message }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

                <div class="col-md-12">
                  <div
                    class="alert alert-danger alert-dismissible fade show"
                    role="alert"
                    v-if="error"
                  >
                    <strong>Error!</strong> {{ error }}
                    <button
                      type="button"
                      class="close"
                      data-dismiss="alert"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-header">
                <h3>Upload Training Curriculum</h3>
                <p>PDF only</p>
                <br />
              </div>
              <!-- <div class="row">
                <div class="col-sm-12">
                  <p>
                    Note: please do not change the layout of the cells in the
                    excel, you are expected to add your data below the column
                    header (first row) in first sheet only. <br />
                    Regards <strong>TrainingProgramme Number</strong> column you
                    are expected to get the value from its representing sheet.
                    <br />
                  </p>
                </div>
                <div class="col-12">
                  <a
                    @click="downloadTemplate"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Download Template</a
                  >
                </div>
              </div>
              <hr />
              <hr /> -->
              <div class="row">
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Upload File</label>
                    <div class="custom-file">
                      <input
                        type="file"
                        name="file"
                        class="form-control"
                        id="cv_upload"
                        @change="onFilePicked"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-3">
                  <a
                    @click="importProviderCurriculum"
                    v-if="file"
                    class="btn btn-primary continue-btn"
                    data-dismiss="modal"
                  >
                    Import</a
                  >
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Upload and Download Curriculum -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import EmployeeSidebar from "@/components/layouts/employeeSidebar.vue"
import { required, sameAs } from "vuelidate/lib/validators";
import { trainingService } from "@/services/trainingService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    EmployeeSidebar,
    Datepicker
  },

  data() {
    return {
      dialog: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      curriculumDialogBox: false,
      headers: [
        { text: "Skill Gap", value: "trainingProgramme.skillGap.name" },
        { text: "Program", value: "trainingProgramme.programme" },
        { text: "Vendor", value: "vendor" },
        { text: "Type", value: "type" },
        { text: "Tuition Fee", value: "tuitionFee" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      skillGapId: 0,
      trainingProgrammeId: 0,
      vendor: "",
      message: "",
      type: 0,
      noOfParticipant: 0,
      tuitionFee: 0,
      provider: {
        trainingProgramme: {}
      },
      loading: false,
      error: "",
      providers: [],
      submitted: false,
      queries: [],
      trainingPrograms: [],
      skillGaps: [],
      currentUser: authenticationService.currentUserValue,
      //employee: authenticationService.currentOfficeValue,
      company: authenticationService.currentOfficeValue,
      user: authenticationService.currentUserValue,
      file: null,
      fileName: ""
    };
  },

  validations: {
    skillGap: { required },
    program: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    }
  },
  methods: {
    getSkillGaps() {
      trainingService.getSkillGap(this.company.id).then(
        model => {
          this.skillGaps = model;
        },
        error => {
          error = error;
        }
      );
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },
    getProgrammes() {
      trainingService
        .getTrainingProgrammesBySkillGap(this.skillGapId)
        .then(r => {
          this.trainingPrograms = r;
        });
    },
    getProviders() {
      trainingService.getTrainingProviders(this.company.id).then(r => {
        this.providers = r;
      });
    },
    openDialog() {
      this.dialog = true;
    },
    openImport() {
      this.dialogImport = true;
    },
    openCurriculumBox(model) {
      this.provider = model;
      console.log(model);
      this.curriculumDialogBox = true;
    },
    close() {
      this.clearList();
      this.dialog = false;
    },
    closeImport() {
      this.dialogImport = false;
    },
    closecurriculumDialogBox() {
      this.curriculumDialogBox = false;
      this.clearMessage();
    },

    clearMessage() {
      this.message = "";
    },
    closeEdit() {
      this.dialogEdit = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    clearList() {
      this.skillGapId = 0;
      this.trainingProgrammeId = 0;
      this.vendor = "";
      this.type = 0;
      this.noOfParticipant = 0;
      this.tuitionFee = 0;
      this.startDate = "";
      this.endDate = "";
      this.submitted = false;
    },
    setEditProvider(model) {
      this.provider = model;
      this.skillGapId = model.trainingProgramme.skillGapId;
      this.getProgrammes();
      this.dialogEdit = true;
    },
    setDeleteProvider(model) {
      this.provider = model;
      this.dialogDelete = true;
    },

    onDeleteSubmit() {
      const id = this.provider.id;
      trainingService.removeProvider(id).then(id => {
        trainingService.getTrainingProviders(this.company.id).then(r => {
          this.providers = r;
          this.closeDelete();
        });
      });
    },

    importProvider() {
      trainingService.importProvider(this.company.id, this.file).then(id => {
        trainingService.getTrainingProviders(this.company.id).then(r => {
          this.providers = r;
          this.closeImport();
        });
      });
    },

    importProviderCurriculum() {
      console.log("upload file:", this.provider.id, this.file);

      trainingService
        .importProviderCurriculum(this.provider.id, this.file)
        .then(id => {
          this.message = "Provider Curriculum upload successfully";
          trainingService.getTrainingProviders(this.company.id).then(r => {
            this.providers = r;

            this.closecurriculumDialogBox();
          });
        });
    },

    onSubmit() {
      this.submitted = true;

      this.loading = true;
      var req = {
        companyId: this.company.id,
        skillGapId: this.skillGapId,
        trainingProgrammeId: this.trainingProgrammeId,
        vendor: this.vendor,
        type: this.type,
        noOfParticipant: this.noOfParticipant,
        tuitionFee: this.tuitionFee
      };
      trainingService.addProvider(req).then(
        id => {
          this.message = "Training Provider created successfully";
          trainingService.getTrainingProviders(this.company.id).then(r => {
            this.providers = r;
            this.close();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    downloadTemplate() {
      trainingService.downloadProviderTemplate(this.company.id).then(
        response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          this.error = error;
        }
      );
    },

    downloalProviderCurriculum() {
      trainingService.downloadProviderTemplate(this.company.id).then(
        response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          this.error = error;
        }
      );
    },
    onPutSubmit() {
      this.loading = true;
      trainingService.editProvider(this.provider).then(
        id => {
          trainingService.getTrainingProviders(this.company.id).then(r => {
            this.providers = r;
            this.closeEdit();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    }
  },

  mounted() {
    this.getSkillGaps();
    this.getProviders();
    this.getProgrammes();
    // Datatable
    //this.getEmployees(this.employee.id);
    //this.getEmployeedisciplinaryMeasures(this.company.id);

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    $(document).on("change", "#customleave_select", function() {
      //$(this).find('option:selected')
      return false;
    });
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "trainingProvider"
};
</script>



// WEBPACK FOOTER //
// src/components/training/trainingProvider.vue